import InGamePlayerCard from './in-game-player-card';

export default InGamePlayerCard;
